var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappyAsset51(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 29,
    viewBox: "0 0 48 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "happyAsset 5 1",
    clipPath: "url(#clip0_5253_13096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 4"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.3131 12.69C44.1115 11.4665 43.7313 10.2798 43.1849 9.16855C42.9096 8.61422 42.5928 8.08187 42.2372 7.57614C42.0589 7.3259 41.8672 7.08022 41.6663 6.84591C41.4654 6.60446 41.2491 6.37649 41.0188 6.16345L40.8224 5.98828L40.2087 6.71624L40.4186 6.85728C40.8023 7.26495 41.144 7.71083 41.4384 8.18808C41.7483 8.66286 42.0214 9.16101 42.2553 9.67811C42.7251 10.7114 43.0407 11.8092 43.1916 12.9357C43.3444 14.0607 43.3505 15.201 43.2097 16.3275C43.0797 17.4438 42.7695 18.5312 42.2914 19.5465C41.8089 20.563 41.1876 21.5063 40.4456 22.3491C39.3279 23.6254 38.0043 24.7021 36.5308 25.5339C36.2804 25.6727 36.0322 25.8024 35.7907 25.9161C35.5473 26.0329 35.2972 26.1347 35.0416 26.2209C34.9717 26.2437 34.9175 26.2596 34.8679 26.271L34.755 26.2915L34.6783 26.3074L34.2496 26.3893L33.3922 26.5644C32.8123 26.6873 32.2392 26.8124 31.6864 26.9398L31.208 27.0513L31.5194 28.4162L31.9977 28.307C32.5506 28.1796 33.144 28.0454 33.7397 27.918L34.6106 27.7383L35.0461 27.6541C35.2172 27.6222 35.3854 27.5765 35.5493 27.5176C36.1387 27.2999 36.708 27.0304 37.2506 26.7123C37.7858 26.4046 38.3034 26.0666 38.8007 25.7C39.7972 24.9668 40.7058 24.1194 41.5084 23.1749C42.3173 22.2245 42.9853 21.1609 43.4917 20.0174C44.0004 18.8736 44.3183 17.653 44.4327 16.4049C44.5559 15.1667 44.5156 13.9175 44.3131 12.69ZM43.943 16.3503C43.8327 17.5458 43.5277 18.7148 43.0405 19.8104C42.5519 20.9075 41.9081 21.9273 41.1293 22.8382C40.3525 23.754 39.4727 24.5754 38.5074 25.286C38.0263 25.6415 37.5253 25.9688 37.0069 26.2664C36.4904 26.5703 35.9483 26.8276 35.3868 27.0353C35.2458 27.0863 35.1009 27.1259 34.9536 27.1536L34.5136 27.2378L33.6359 27.4198C33.0379 27.5472 32.4423 27.6814 31.8872 27.8088L31.7947 27.4084C32.3452 27.281 32.9229 27.1559 33.4892 27.0353L34.3399 26.8602L34.7686 26.7783L34.8408 26.7646L34.9807 26.7373C35.0393 26.7237 35.1048 26.7032 35.1905 26.6759C35.4654 26.5843 35.7344 26.4757 35.996 26.3506C36.2488 26.2323 36.5082 26.0981 36.77 25.9502C37.2753 25.6659 37.7642 25.353 38.2344 25.013C39.1805 24.3344 40.0458 23.5482 40.8134 22.6699C41.5851 21.7926 42.2314 20.811 42.7336 19.7535C43.2356 18.6889 43.5611 17.5484 43.6971 16.3776C43.8435 15.2088 43.8374 14.0256 43.679 12.8584C43.4456 11.09 42.8202 9.39732 41.8491 7.90599C41.8243 7.8696 41.7995 7.8332 41.7769 7.7968L41.8265 7.86732C42.1655 8.35063 42.4672 8.85942 42.7291 9.38921C43.2563 10.4564 43.6243 11.5963 43.8212 12.7719C44.0185 13.954 44.0595 15.1573 43.943 16.3503Z",
    fill: "#681D07"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.0716 12.7407C43.8692 11.5407 43.4929 10.3771 42.9547 9.28747C42.6853 8.74722 42.3753 8.22855 42.0274 7.73601C41.8536 7.49033 41.6663 7.25374 41.47 7.02398C41.2743 6.79293 41.0641 6.57485 40.8405 6.37109L40.5743 6.6873C40.5743 6.6873 40.6036 6.7146 40.6397 6.75327L40.572 6.6873C40.9751 7.10487 41.3357 7.56213 41.6483 8.05222C42.5987 9.51297 43.211 11.1706 43.4399 12.9022C43.5959 14.0483 43.602 15.2101 43.4579 16.3578C43.3237 17.5004 43.0067 18.6136 42.5193 19.654C42.0259 20.6907 41.3918 21.6531 40.6352 22.5135C39.4978 23.8074 38.1522 24.8987 36.6549 25.7416C36.4067 25.8804 36.154 26.0123 35.899 26.1329C35.6464 26.2546 35.3864 26.3602 35.1206 26.4491C35.0574 26.4695 34.992 26.4877 34.931 26.5014C34.8701 26.515 34.8002 26.5287 34.728 26.5423L34.297 26.6174L33.4418 26.7926C32.8732 26.9131 32.3136 27.036 31.7405 27.1679L31.5013 27.2225L31.5578 27.4637L31.6503 27.8663L31.7044 28.0938L31.9436 28.0392C32.5235 27.9073 33.1056 27.7753 33.69 27.6525C33.9811 27.5888 34.2722 27.5296 34.5655 27.4705L35.0032 27.3863C35.161 27.3552 35.3164 27.3126 35.4681 27.2589C36.0437 27.0467 36.5994 26.7832 37.1288 26.4718C37.6566 26.1696 38.1666 25.8369 38.6563 25.4754C39.6374 24.7546 40.531 23.9201 41.3189 22.989C42.1127 22.0591 42.7692 21.0186 43.2684 19.8997C43.7616 18.7844 44.0725 17.596 44.189 16.3805C44.3092 15.1673 44.2697 13.9435 44.0716 12.7407Z",
    fill: "url(#paint0_linear_5253_13096)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M35.9713 27.7108C35.9374 27.6608 35.9072 27.6083 35.881 27.5538L35.8381 27.4719L35.8607 27.3832C35.8742 27.3195 36.2533 25.8295 38.4555 25.1311C40.6578 24.4327 42.6186 25.7021 42.702 25.7544L42.9277 25.9046L42.7585 26.1184C42.1188 26.8937 41.3564 27.557 40.5021 28.0816C38.6496 29.1849 36.6662 28.78 35.9713 27.7108ZM36.3661 27.4128L36.3819 27.4401C36.9415 28.2977 38.6654 28.598 40.2471 27.6676C40.9675 27.2232 41.6203 26.6761 42.1853 26.0433C41.61 25.7476 40.1365 25.1334 38.6022 25.6157C36.9528 26.1275 36.4767 27.1125 36.3661 27.4128Z",
    fill: "#681D07"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M36.1021 27.4416C36.1021 27.4416 36.4361 26.0334 38.53 25.3692C40.6239 24.7049 42.5712 25.9652 42.5712 25.9652C41.9461 26.7159 41.2047 27.3596 40.3757 27.8715C38.6405 28.902 36.6594 28.5471 36.1021 27.4416Z",
    fill: "url(#paint1_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3117 25.9635C42.3117 25.9635 39.9854 24.8943 38.3653 25.7496C36.7452 26.605 37.7583 28.2133 38.9 28.1314C40.0418 28.0495 42.4403 26.1614 42.3117 25.9635Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0838 26.049C42.0838 26.049 40.4524 27.4344 39.6807 27.3229C38.9091 27.2115 38.7173 26.115 39.4393 25.6554C40.1613 25.1959 42.0838 26.049 42.0838 26.049Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M40.8405 23.8644C40.7976 23.8212 40.757 23.7757 40.7186 23.7302L40.66 23.6597V23.5664C40.66 23.5027 40.7186 21.974 42.7246 20.8116C44.7305 19.6491 46.9124 20.4817 47.0117 20.5158L47.2667 20.6114L47.1584 20.8571C46.6917 21.7531 46.0818 22.5655 45.3532 23.2616C43.7738 24.7334 41.743 24.7607 40.8405 23.8644ZM41.1631 23.4891L41.1857 23.5096C41.9123 24.2307 43.6677 24.1579 45.008 22.8976C45.6179 22.3096 46.1407 21.6362 46.5604 20.898C45.9377 20.732 44.365 20.443 42.9705 21.2438C41.4768 22.1082 41.2173 23.1729 41.1722 23.4891H41.1631Z",
    fill: "#681D07"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M40.9172 23.5709C40.9172 23.5709 40.9511 22.1218 42.8577 21.0253C44.7644 19.9288 46.9327 20.7455 46.9327 20.7455C46.4799 21.6131 45.89 22.4006 45.1863 23.0772C43.7084 24.4558 41.6957 24.5286 40.9172 23.5709Z",
    fill: "url(#paint2_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_9",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.68 20.8006C46.68 20.8006 44.18 20.2478 42.7765 21.433C41.373 22.6183 42.702 23.9718 43.8009 23.6488C44.8998 23.3257 46.847 20.9735 46.68 20.8006Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_10",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4815 20.9295C46.4815 20.9295 45.1773 22.6311 44.4011 22.6879C43.6249 22.7448 43.2052 21.712 43.8144 21.1092C44.4236 20.5063 46.4815 20.9295 46.4815 20.9295Z",
    fill: "white"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M44.3559 18.0707C44.3063 18.0548 44.2544 18.0366 44.207 18.0162L44.1325 17.9866L44.0964 17.9138C44.0694 17.8637 43.4782 16.6467 44.5477 14.911C45.6172 13.1752 47.6593 12.8932 47.745 12.8818L47.9819 12.8477V13.0888C47.9999 13.9732 47.8741 14.8546 47.6096 15.6981C46.9846 17.518 45.4277 18.3847 44.3559 18.0707ZM44.4529 17.6431H44.4778C45.3397 17.8979 46.6642 17.1039 47.1854 15.5593C47.4151 14.8474 47.5412 14.1056 47.56 13.3572C47.0094 13.4914 45.6714 13.9259 44.92 15.1362C44.1145 16.4442 44.3559 17.3792 44.4507 17.6431H44.4529Z",
    fill: "#681D07"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M44.2882 17.8135C44.2882 17.8135 43.7151 16.676 44.7395 15.0267C45.7639 13.3775 47.7811 13.0977 47.7811 13.0977C47.7864 13.96 47.6523 14.8175 47.384 15.6364C46.8199 17.3266 45.2901 18.2298 44.2882 17.8135Z",
    fill: "url(#paint3_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_13",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6096 13.2383C47.6096 13.2383 45.448 13.8661 44.8478 15.3721C44.2476 16.8781 45.8384 17.3717 46.5559 16.6597C47.2734 15.9476 47.8104 13.3043 47.6096 13.2383Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_14",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5058 13.4219C47.5058 13.4219 47.199 15.2895 46.6191 15.6603C46.0392 16.0311 45.2878 15.4078 45.5112 14.6822C45.7346 13.9565 47.5058 13.4219 47.5058 13.4219Z",
    fill: "white"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M44.3447 12.7646C44.2925 12.774 44.2397 12.7801 44.1867 12.7828H44.1055L44.0423 12.735C43.9972 12.7009 42.9322 11.8751 43.1398 9.83684C43.3474 7.79856 45.0329 6.64293 45.1028 6.59743L45.3014 6.46094L45.4165 6.67478C45.8165 7.46699 46.0848 8.32003 46.2107 9.19988C46.4544 11.088 45.4435 12.5667 44.3447 12.7646ZM44.2431 12.3392H44.268C45.1525 12.18 45.9896 10.8765 45.7797 9.25902C45.671 8.51813 45.4582 7.79661 45.148 7.1161C44.7125 7.48235 43.7039 8.48102 43.5685 9.89144C43.4128 11.4156 44.0401 12.1436 44.2431 12.3392Z",
    fill: "#681D07"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M44.1709 12.5652C44.1709 12.5652 43.1578 11.8032 43.3474 9.86498C43.5369 7.92679 45.2247 6.77344 45.2247 6.77344C45.6113 7.54343 45.8711 8.37167 45.9941 9.22574C46.2242 10.9956 45.2517 12.4902 44.1709 12.5652Z",
    fill: "url(#paint4_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_17",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1276 6.98471C45.1276 6.98471 43.4647 8.51342 43.5888 10.1308C43.7129 11.7483 45.3578 11.4776 45.6872 10.5198C46.0166 9.56213 45.3533 6.95058 45.1276 6.98471Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_18",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1276 7.19922C45.1276 7.19922 45.6759 9.01911 45.3194 9.60148C44.9629 10.1838 44.0152 9.96773 43.8956 9.22158C43.776 8.47542 45.1276 7.19922 45.1276 7.19922Z",
    fill: "white"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M35.3304 27.0135C35.2695 27.0135 35.2086 27.0135 35.1499 27.0135H35.0597L34.9942 26.9498C34.9468 26.9066 33.866 25.8124 34.3827 23.5557C34.8995 21.299 36.9798 20.2253 37.0678 20.1798L37.3093 20.0547L37.4085 20.3117C37.7447 21.2617 37.9246 22.2606 37.941 23.2691C37.9478 25.4325 36.5962 26.9521 35.3304 27.0135ZM35.2763 26.5199H35.3056C36.3255 26.4698 37.4559 25.1231 37.4492 23.2691C37.4343 22.4196 37.2975 21.5767 37.043 20.7667C36.4992 21.1148 35.2221 22.0839 34.8611 23.6626C34.4752 25.3574 35.0754 26.2719 35.2763 26.5199Z",
    fill: "#681D07"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M35.1634 26.7625C35.1634 26.7625 34.13 25.757 34.6219 23.6005C35.1138 21.4439 37.1784 20.3906 37.1784 20.3906C37.5039 21.3138 37.6784 22.2842 37.6951 23.2638C37.7018 25.293 36.3909 26.8421 35.1634 26.7625Z",
    fill: "url(#paint5_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_21",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0453 20.6133C37.0453 20.6133 34.9536 22.0965 34.8633 23.9346C34.7731 25.7727 36.6685 25.7113 37.1716 24.6785C37.6748 23.6457 37.2867 20.6065 37.0453 20.6133Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_22",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0046 20.8555C37.0046 20.8555 37.3634 22.9734 36.8783 23.5853C36.3932 24.1972 35.3552 23.8128 35.3281 22.9506C35.3011 22.0884 37.0046 20.8555 37.0046 20.8555Z",
    fill: "white"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M40.7344 23.0768C40.6825 23.1087 40.6307 23.1382 40.5765 23.1655L40.4953 23.2042L40.4073 23.1815C40.3441 23.1633 38.8774 22.7424 38.2411 20.5062C37.6048 18.27 38.9181 16.325 38.9722 16.2431L39.1234 16.0156L39.3332 16.1931C40.0853 16.8607 40.7234 17.6484 41.2218 18.5248C42.2665 20.4152 41.813 22.4057 40.7344 23.0768ZM40.4501 22.6719L40.475 22.656C41.3437 22.1145 41.6866 20.3811 40.7909 18.7659C40.3694 18.0291 39.8451 17.3572 39.234 16.7709C38.9248 17.3419 38.2727 18.8183 38.715 20.3697C39.1911 22.0463 40.1636 22.5536 40.4501 22.6719Z",
    fill: "#681D07"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M40.4705 22.9419C40.4705 22.9419 39.0828 22.5665 38.4781 20.4395C37.8734 18.3125 39.1753 16.3789 39.1753 16.3789C39.9042 17.0316 40.5223 17.8 41.0052 18.6538C41.9845 20.4191 41.5784 22.4073 40.4705 22.9419Z",
    fill: "url(#paint6_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_25",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M39.164 16.6413C39.164 16.6413 38.0358 18.9594 38.8504 20.6132C39.6649 22.2671 41.2782 21.2957 41.2263 20.1355C41.1744 18.9753 39.3716 16.5162 39.164 16.6413Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_26",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2452 16.875C39.2452 16.875 40.5765 18.5539 40.4456 19.3296C40.3147 20.1053 39.2227 20.2691 38.7872 19.5298C38.3517 18.7904 39.2452 16.875 39.2452 16.875Z",
    fill: "white"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M43.5865 12.6856C43.5652 12.7347 43.5411 12.7826 43.5143 12.8289L43.4759 12.8995L43.4015 12.929C43.3473 12.9472 42.0792 13.3954 40.4975 12.1101C38.9158 10.8248 38.882 8.75465 38.8797 8.6682V8.41797L39.1189 8.43844C39.9952 8.53322 40.85 8.77383 41.6483 9.15048C43.3496 9.98763 44.0242 11.6506 43.5865 12.6856ZM43.1759 12.54C43.1792 12.5315 43.1829 12.5231 43.1871 12.515C43.5391 11.6824 42.9164 10.2629 41.4587 9.55768C40.7844 9.24272 40.0685 9.02743 39.3332 8.91844C39.3987 9.48716 39.6694 10.8794 40.7705 11.7734C41.9551 12.7402 42.9051 12.6037 43.1759 12.54Z",
    fill: "#681D07"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M43.3225 12.7224C43.3225 12.7224 42.1357 13.1615 40.6307 11.9399C39.1256 10.7183 39.0918 8.66406 39.0918 8.66406C39.9428 8.75952 40.7727 8.99385 41.549 9.3579C43.1488 10.1314 43.855 11.7715 43.3225 12.7224Z",
    fill: "url(#paint7_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_29",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2181 8.85195C39.2181 8.85195 39.5792 11.0927 40.9894 11.8707C42.3996 12.6487 43.0766 11.1177 42.4606 10.3147C41.8446 9.51166 39.3061 8.65859 39.2181 8.85195Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_30",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3942 8.98047C39.3942 8.98047 41.1993 9.51051 41.4926 10.1361C41.7859 10.7617 41.0842 11.4373 40.3983 11.1279C39.7123 10.8186 39.3942 8.98047 39.3942 8.98047Z",
    fill: "white"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M42.0589 7.34839C42.0393 7.39789 42.0159 7.4458 41.989 7.49171L41.9506 7.56223L41.8762 7.5918C41.822 7.61 40.5539 8.04678 38.9722 6.77285C37.3905 5.49893 37.3566 3.4106 37.3544 3.33098V3.08984L37.5935 3.10804C38.4705 3.20509 39.3257 3.44639 40.1252 3.82235C41.8243 4.6504 42.4989 6.31333 42.0589 7.34839ZM41.6505 7.2028V7.1755C42.0025 6.34518 41.3798 4.92339 39.9221 4.21818C39.2478 3.90323 38.5319 3.68793 37.7966 3.57894C37.8621 4.14766 38.1328 5.53988 39.2339 6.4339C40.4298 7.39617 41.3775 7.27787 41.6505 7.2028Z",
    fill: "#681D07"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M41.8017 7.3855C41.8017 7.3855 40.6148 7.82455 39.1098 6.59612C37.6048 5.36769 37.571 3.32031 37.571 3.32031C38.4205 3.41241 39.2496 3.64289 40.0259 4.00277C41.6234 4.79443 42.3297 6.43461 41.8017 7.3855Z",
    fill: "url(#paint8_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_33",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6929 3.51992C37.6929 3.51992 38.0539 5.76066 39.4641 6.53867C40.8744 7.31667 41.5513 5.78569 40.9353 4.98266C40.3193 4.17963 37.7809 3.32656 37.6929 3.51992Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_34",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8688 3.64062C37.8688 3.64062 39.6739 4.17067 39.9673 4.79626C40.2606 5.42185 39.5589 6.09748 38.8729 5.7881C38.187 5.47872 37.8688 3.64062 37.8688 3.64062Z",
    fill: "white"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M43.6113 18.1998C43.582 18.243 43.5481 18.2862 43.5143 18.3272L43.4601 18.3863H43.3812C43.327 18.3863 41.9935 18.5729 40.7051 16.9896C39.4167 15.4063 39.8025 13.3725 39.8183 13.2861L39.8635 13.0586L40.0891 13.1268C40.9262 13.3975 41.7137 13.8048 42.4199 14.3325C43.9272 15.5018 44.2499 17.2694 43.6113 18.1998ZM43.2413 17.9723L43.2548 17.9496C43.7693 17.208 43.4466 15.6883 42.1627 14.6942C41.5667 14.2478 40.9102 13.89 40.2132 13.6319C40.1613 14.2029 40.1433 15.6201 41.0413 16.7234C42.007 17.9041 42.9615 17.9723 43.2413 17.9723Z",
    fill: "#681D07"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M43.3496 18.1752C43.3496 18.1752 42.0996 18.3618 40.8676 16.8558C39.6356 15.3498 40.026 13.332 40.026 13.332C40.8363 13.6013 41.5983 14.0007 42.2823 14.515C43.6993 15.6023 44.0604 17.354 43.3496 18.1752Z",
    fill: "url(#paint9_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_37",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1117 13.5463C40.1117 13.5463 40.0124 15.8211 41.2399 16.8653C42.4673 17.9095 43.4376 16.5559 42.9976 15.6437C42.5576 14.7315 40.238 13.3734 40.1117 13.5463Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_38",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2583 13.7031C40.2583 13.7031 41.9168 14.5926 42.0792 15.266C42.2417 15.9393 41.4159 16.4557 40.8066 16.0121C40.1974 15.5685 40.2583 13.7031 40.2583 13.7031Z",
    fill: "white"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M3.56511 16.401C3.682 17.6517 4.00217 18.8745 4.51279 20.0203C5.02117 21.1618 5.69073 22.223 6.50066 23.171C7.30312 24.1157 8.21177 24.9631 9.20832 25.6961C9.7068 26.0623 10.2251 26.4002 10.7607 26.7085C11.3031 27.027 11.8724 27.2965 12.462 27.5138C12.6259 27.5727 12.7941 27.6183 12.9652 27.6502L13.4007 27.7344L14.2694 27.9141C14.8673 28.0415 15.4608 28.1757 16.0136 28.3031L16.4919 28.4123L16.8033 27.0474L16.3249 26.9359C15.7721 26.8085 15.1968 26.6834 14.6191 26.5606L13.7617 26.3854L13.333 26.3035L13.2563 26.2876L13.1434 26.2671C13.0938 26.2671 13.0397 26.2398 12.9675 26.2171C12.7128 26.1304 12.4634 26.0286 12.2206 25.9123C11.9792 25.7985 11.7287 25.6688 11.4782 25.5301C10.9895 25.2535 10.5164 24.9497 10.0612 24.6201C9.14527 23.9613 8.30786 23.1979 7.56567 22.3453C6.81973 21.5032 6.19464 20.5598 5.70867 19.5426C5.23049 18.5273 4.92028 17.44 4.79032 16.3237C4.64841 15.1972 4.65448 14.0568 4.80838 12.9319C4.95963 11.8057 5.27438 10.7081 5.74252 9.67425C5.97836 9.15989 6.25215 8.6641 6.56158 8.19104C6.85998 7.7205 7.2047 7.2815 7.59049 6.88072L7.79808 6.73968L7.18435 6.01172L6.9903 6.18688C6.75937 6.39934 6.54301 6.62735 6.34272 6.86934C6.1419 7.09683 5.9501 7.34934 5.77185 7.59958C5.41544 8.10478 5.09859 8.63719 4.82417 9.19198C4.27484 10.303 3.89089 11.4896 3.6847 12.7135C3.48563 13.9322 3.44543 15.1718 3.56511 16.401ZM4.16982 12.7772C4.36855 11.6017 4.73726 10.462 5.26416 9.39445C5.52602 8.86465 5.82775 8.35587 6.16672 7.87256L6.21636 7.80204L6.14415 7.91123C5.82068 8.40748 5.53482 8.92762 5.28898 9.46724C4.80056 10.545 4.47213 11.6894 4.31423 12.8636C4.15751 14.0303 4.15296 15.2127 4.30069 16.3806C4.43832 17.5501 4.76293 18.6893 5.26191 19.7542C5.76582 20.8108 6.41197 21.7922 7.18209 22.6706C8.33785 23.9859 9.70565 25.0949 11.2278 25.9509C11.4895 26.0988 11.749 26.233 12.0017 26.3513C12.2633 26.4764 12.5323 26.585 12.8072 26.6766C12.8907 26.7039 12.9584 26.7244 13.0171 26.738L13.157 26.7653L13.2292 26.779L13.6579 26.8609L14.5063 27.036C15.0817 27.1566 15.6525 27.2817 16.2008 27.4091L16.1106 27.8095C15.5555 27.6821 14.9598 27.5479 14.3596 27.4205L13.4819 27.2385L13.0442 27.1543C12.8969 27.1265 12.752 27.087 12.6109 27.036C12.0495 26.8283 11.5074 26.571 10.9909 26.2671C10.4721 25.969 9.97037 25.6417 9.48811 25.2867C8.5237 24.5768 7.64456 23.7561 6.86845 22.8412C6.09201 21.9299 5.45056 20.91 4.96407 19.8133C4.47579 18.7181 4.17081 17.5489 4.06151 16.3533C3.94183 15.1616 3.97824 13.9592 4.16982 12.7772Z",
    fill: "#681D07"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M3.92835 12.7407C4.12928 11.5388 4.50567 10.3736 5.04526 9.28292C5.31401 8.74376 5.62407 8.22655 5.97263 7.73601C6.14637 7.49033 6.33365 7.25374 6.5277 7.02398C6.72273 6.79305 6.93225 6.57497 7.15497 6.37109L7.42123 6.6873C7.42123 6.6873 7.39189 6.7146 7.35579 6.75327L7.42348 6.6873C7.01971 7.10428 6.65909 7.56161 6.34719 8.05222C6.03142 8.53887 5.75163 9.0483 5.51007 9.57638C5.03302 10.6324 4.71075 11.7527 4.55337 12.9022C4.39808 14.0484 4.39277 15.2102 4.53757 16.3578C4.67069 17.5006 4.98774 18.614 5.47623 19.654C5.96877 20.6912 6.60295 21.6537 7.3603 22.5135C8.49779 23.8064 9.84248 24.8976 11.3383 25.7416C11.5865 25.8804 11.8392 26.0123 12.0964 26.1329C12.3483 26.2546 12.6076 26.3602 12.8726 26.4491C12.9381 26.4695 13.0035 26.4877 13.0644 26.5014C13.1254 26.515 13.1953 26.5287 13.2653 26.5423L13.694 26.6242L14.5491 26.7994C15.1177 26.92 15.6773 27.0428 16.2504 27.1747L16.4761 27.2293L16.4219 27.4705L16.3294 27.8731L16.2753 28.1006L16.0361 28.046C15.4539 27.9141 14.8718 27.7821 14.2897 27.6593C13.9986 27.5956 13.7075 27.5365 13.4142 27.4773L12.9764 27.3931C12.8187 27.362 12.6633 27.3194 12.5116 27.2657C11.9357 27.0544 11.3798 26.7909 10.8509 26.4786C10.33 26.175 9.82676 25.8416 9.34366 25.48C8.36262 24.7592 7.46899 23.9246 6.68113 22.9935C5.8897 22.0666 5.23535 21.0291 4.73839 19.9134C4.24037 18.7946 3.92711 17.6012 3.81102 16.3805C3.69084 15.1673 3.73029 13.9435 3.92835 12.7407Z",
    fill: "url(#paint10_linear_5253_13096)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M7.5002 28.0828C6.64606 27.558 5.88369 26.8947 5.24381 26.1196L5.07458 25.9058L5.30022 25.7556C5.38371 25.7033 7.36933 24.4407 9.54673 25.1323C11.7241 25.8239 12.128 27.3207 12.1416 27.3844L12.1641 27.4731L12.1213 27.555C12.0942 27.6091 12.0641 27.6615 12.031 27.712C11.3338 28.7812 9.35043 29.1861 7.5002 28.0828ZM9.39781 25.6055C7.86347 25.1187 6.3878 25.7374 5.81468 26.0331C6.37969 26.666 7.03253 27.213 7.75291 27.6574C9.33238 28.5992 11.0585 28.2989 11.6181 27.4299C11.6225 27.4203 11.6278 27.4112 11.6339 27.4026C11.5233 27.1137 11.0563 26.1287 9.39781 25.6055Z",
    fill: "#681D07"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M11.9001 27.4416C11.9001 27.4416 11.5639 26.0334 9.47227 25.3692C7.3806 24.7049 5.43109 25.9652 5.43109 25.9652C6.05611 26.7159 6.79751 27.3596 7.62655 27.8715C9.35945 28.902 11.3406 28.5471 11.9001 27.4416Z",
    fill: "url(#paint11_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_43",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68832 25.9635C5.68832 25.9635 8.01465 24.8943 9.63248 25.7496C11.2503 26.605 10.2417 28.2133 9.09997 28.1314C7.95824 28.0495 5.55971 26.1614 5.68832 25.9635Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_44",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M5.914 26.049C5.914 26.049 7.54537 27.4344 8.3193 27.3229C9.09324 27.2115 9.28278 26.115 8.56074 25.6554C7.83869 25.1959 5.914 26.049 5.914 26.049Z",
    fill: "white"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M2.64674 23.2597C1.91848 22.5632 1.30865 21.7509 0.84164 20.8551L0.728821 20.6094L0.983792 20.5139C1.0763 20.4798 3.28079 19.6699 5.27092 20.8096C7.26104 21.9493 7.33325 23.5008 7.33551 23.5645V23.6578L7.27684 23.7283C7.23848 23.7738 7.19787 23.8193 7.15499 23.8625C6.24793 24.7588 4.2217 24.7315 2.64674 23.2597ZM5.02046 21.2419C3.62601 20.4388 2.05332 20.73 1.43056 20.8961C1.85024 21.6342 2.37306 22.3076 2.98295 22.8957C4.33677 24.156 6.0787 24.2288 6.80526 23.5076L6.82556 23.4872C6.78269 23.1709 6.52321 22.1063 5.02046 21.2419Z",
    fill: "#681D07"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M7.08053 23.5709C7.08053 23.5709 7.04894 22.1218 5.1423 21.0253C3.23565 19.9288 1.08081 20.7455 1.08081 20.7455C1.53335 21.6127 2.12239 22.4002 2.82499 23.0772C4.28713 24.4558 6.30208 24.5286 7.08053 23.5709Z",
    fill: "url(#paint12_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_47",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31996 20.8006C1.31996 20.8006 3.82003 20.2478 5.22124 21.433C6.62245 22.6183 5.29796 23.9718 4.1991 23.6488C3.10024 23.3257 1.15298 20.9735 1.31996 20.8006Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_48",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1.52307 20.9305C1.52307 20.9305 2.82726 22.6367 3.61022 22.6936C4.39319 22.7504 4.80611 21.7176 4.19688 21.1148C3.58766 20.512 1.52307 20.9305 1.52307 20.9305Z",
    fill: "white"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M0.401644 15.6981C0.127201 14.8563 -0.00847797 13.9748 8.61168e-06 13.0888V12.8477L0.236929 12.8818C0.324928 12.8932 2.36921 13.1912 3.43422 14.911C4.49923 16.6308 3.9216 17.8683 3.8855 17.9138L3.8494 17.9866L3.77493 18.0162C3.72755 18.0366 3.67565 18.0548 3.62601 18.0707C2.57228 18.3847 1.01538 17.518 0.401644 15.6981ZM3.07771 15.1339C2.32634 13.9237 0.988304 13.4892 0.43549 13.355C0.455538 14.1064 0.582437 14.851 0.812306 15.5661C1.33579 17.1108 2.66028 17.9047 3.51996 17.6499H3.54478C3.64406 17.3792 3.88324 16.4442 3.07771 15.143V15.1339Z",
    fill: "#681D07"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M3.71173 17.8135C3.71173 17.8135 4.28485 16.676 3.26045 15.0267C2.23606 13.3775 0.22562 13.0977 0.22562 13.0977C0.215215 13.9592 0.344009 14.8166 0.606949 15.6364C1.18007 17.3266 2.70764 18.2298 3.71173 17.8135Z",
    fill: "url(#paint13_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_51",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0.390356 13.2383C0.390356 13.2383 2.55423 13.8752 3.15894 15.3721C3.76365 16.869 2.16387 17.3717 1.44409 16.6597C0.7243 15.9476 0.189538 13.3043 0.390356 13.2383Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_52",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0.494141 13.4219C0.494141 13.4219 0.801008 15.2895 1.3809 15.6603C1.96079 16.0311 2.70765 15.4169 2.48201 14.6913C2.25637 13.9656 0.494141 13.4219 0.494141 13.4219Z",
    fill: "white"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M1.78933 9.19597C1.91526 8.31613 2.18357 7.46309 2.58357 6.67087L2.69639 6.45703L2.89496 6.59352C2.96716 6.6413 4.66847 7.8265 4.86703 9.84203C5.06559 11.8576 4.00284 12.7061 3.96448 12.7402L3.89904 12.788H3.82007C3.76709 12.7853 3.71434 12.7792 3.66212 12.7698C2.5565 12.565 1.54564 11.0864 1.78933 9.19597ZM4.43606 9.87843C4.29617 8.45891 3.28757 7.46935 2.8566 7.10309C2.5453 7.78321 2.33254 8.50489 2.22481 9.24602C2.01497 10.8634 2.85208 12.1669 3.73659 12.3262H3.76141C3.95997 12.1419 4.58724 11.414 4.43606 9.88526V9.87843Z",
    fill: "#681D07"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M3.83584 12.5652C3.83584 12.5652 4.84896 11.8032 4.65716 9.86498C4.46537 7.92679 2.77534 6.77344 2.77534 6.77344C2.38874 7.54343 2.12887 8.37167 2.00592 9.22574C1.77577 10.9956 2.74827 12.4902 3.83584 12.5652Z",
    fill: "url(#paint14_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_55",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86561 6.98471C2.86561 6.98471 4.52856 8.51342 4.40221 10.1308C4.27585 11.7483 2.63546 11.4776 2.30603 10.5198C1.9766 9.56213 2.65577 6.95058 2.86561 6.98471Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_56",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87464 7.19922C2.87464 7.19922 2.32634 9.01911 2.68285 9.60148C3.03936 10.1838 3.98704 9.96773 4.10662 9.22158C4.22621 8.47542 2.87464 7.19922 2.87464 7.19922Z",
    fill: "white"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M10.0567 23.2652C10.0733 22.2565 10.254 21.2575 10.5915 20.3078L10.6885 20.0508L10.9322 20.1759C11.0202 20.2214 13.1051 21.3133 13.6173 23.5518C14.1295 25.7903 13.0532 26.9027 13.0058 26.9459L12.9404 27.0096H12.8501C12.7892 27.0096 12.7283 27.0096 12.6696 27.0096C11.4015 26.9505 10.0522 25.4308 10.0567 23.2652ZM13.1367 23.6587C12.7779 22.08 11.5008 21.1109 10.957 20.7628C10.7025 21.5728 10.5657 22.4157 10.5509 23.2652C10.5509 25.1192 11.6791 26.4659 12.6922 26.516H12.7238C12.9246 26.2703 13.5248 25.3558 13.1367 23.6587Z",
    fill: "#681D07"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M12.8343 26.7625C12.8343 26.7625 13.87 25.757 13.3781 23.6005C12.8862 21.4439 10.8306 20.3906 10.8306 20.3906C10.5051 21.3138 10.3306 22.2842 10.3139 23.2638C10.2981 25.293 11.6068 26.8421 12.8343 26.7625Z",
    fill: "url(#paint15_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_59",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9548 20.6133C10.9548 20.6133 13.0464 22.0965 13.1344 23.9346C13.2224 25.7727 11.3293 25.7113 10.8284 24.6785C10.3275 23.6457 10.7133 20.6065 10.9548 20.6133Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_60",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9931 20.8555C10.9931 20.8555 10.6366 22.9734 11.1217 23.5853C11.6068 24.1972 12.6447 23.8128 12.6718 22.9506C12.6989 22.0884 10.9931 20.8555 10.9931 20.8555Z",
    fill: "white"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M6.76917 18.5248C7.26682 17.6479 7.90497 16.86 8.65776 16.1931L8.86535 16.0156L9.01878 16.2431C9.07519 16.325 10.3726 18.2905 9.74985 20.5062C9.12708 22.7219 7.6469 23.1633 7.58372 23.1815L7.49572 23.2042L7.41449 23.1655C7.36038 23.1387 7.30767 23.1091 7.25654 23.0768C6.18702 22.4057 5.73349 20.4152 6.76917 18.5248ZM9.27601 20.3697C9.72728 18.8137 9.06616 17.3419 8.75704 16.7709C8.1525 17.3581 7.63499 18.03 7.22044 18.7659C6.31789 20.3856 6.66763 22.1145 7.53408 22.656L7.56116 22.6719C7.84546 22.5536 8.79991 22.0463 9.28503 20.3697H9.27601Z",
    fill: "#681D07"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M7.52954 22.9419C7.52954 22.9419 8.91721 22.5665 9.52192 20.4395C10.1266 18.3125 8.8247 16.3789 8.8247 16.3789C8.09631 17.032 7.47825 17.8004 6.99478 18.6538C6.01325 20.4191 6.4194 22.4073 7.52954 22.9419Z",
    fill: "url(#paint16_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_63",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83602 16.6413C8.83602 16.6413 9.96421 18.9594 9.14965 20.6132C8.3351 22.2671 6.72179 21.2957 6.77368 20.1355C6.82558 18.9753 8.62843 16.5162 8.83602 16.6413Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_64",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75474 16.875C8.75474 16.875 7.42347 18.5539 7.55209 19.3364C7.6807 20.119 8.7773 20.2759 9.21279 19.5366C9.64827 18.7973 8.75474 16.875 8.75474 16.875Z",
    fill: "white"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M6.35395 9.15957C7.15226 8.78292 8.00698 8.54232 8.88335 8.44754L9.12253 8.41797V8.6682C9.12253 8.75465 9.06838 10.8384 7.50245 12.1101C5.93652 13.3817 4.65489 12.9472 4.60074 12.929L4.52628 12.8995L4.48567 12.8289C4.46085 12.7834 4.43828 12.7357 4.41572 12.6856C3.97572 11.6506 4.65038 9.98763 6.35395 9.15957ZM7.2204 11.7688C8.32152 10.8748 8.59228 9.49398 8.65546 8.91389C7.92471 9.02503 7.21351 9.24106 6.54349 9.5554C5.08586 10.2652 4.4631 11.6847 4.8151 12.5127L4.82638 12.5378C5.09489 12.6037 6.04257 12.7402 7.2204 11.7688Z",
    fill: "#681D07"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M4.67299 12.7224C4.67299 12.7224 5.86662 13.1615 7.36486 11.9399C8.86309 10.7183 8.90145 8.66406 8.90145 8.66406C8.05127 8.75976 7.22215 8.99409 6.44651 9.3579C4.85125 10.1314 4.14274 11.7715 4.67299 12.7224Z",
    fill: "url(#paint17_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_67",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77959 8.85195C8.77959 8.85195 8.42083 11.0927 7.01059 11.8707C5.60035 12.6487 4.92343 11.1177 5.53943 10.3147C6.15542 9.51166 8.69385 8.65859 8.77959 8.85195Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_68",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60586 8.98047C8.60586 8.98047 6.80075 9.51051 6.50742 10.1361C6.21409 10.7617 6.91583 11.4373 7.60177 11.1279C8.28771 10.8186 8.60586 8.98047 8.60586 8.98047Z",
    fill: "white"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M7.87928 3.82235C8.67814 3.44679 9.53256 3.2055 10.4087 3.10804L10.6479 3.08984V3.33098C10.6479 3.41742 10.5937 5.5012 9.03003 6.77285C7.46636 8.0445 6.18022 7.61 6.12607 7.5918L6.05161 7.56223L6.011 7.49171C5.98618 7.44621 5.96361 7.39844 5.94105 7.34839C5.50105 6.31333 6.17571 4.6504 7.87928 3.82235ZM8.75476 6.43162C9.85587 5.5376 10.1266 4.15676 10.1898 3.57667C9.45533 3.68602 8.74026 3.90131 8.06656 4.2159C6.60894 4.92339 5.98618 6.34518 6.33817 7.17323L6.34945 7.20053C6.62022 7.27787 7.57016 7.39617 8.75476 6.43162Z",
    fill: "#681D07"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M6.19827 7.3855C6.19827 7.3855 7.38513 7.82455 8.89013 6.59612C10.3951 5.36769 10.429 3.32031 10.429 3.32031C9.57867 3.41217 8.7488 3.64265 7.97179 4.00277C6.37653 4.79443 5.67028 6.43461 6.19827 7.3855Z",
    fill: "url(#paint18_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_71",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3072 3.51992C10.3072 3.51992 9.94616 5.76066 8.53592 6.53867C7.12568 7.31667 6.44876 5.78569 7.06476 4.98266C7.68075 4.17963 10.2192 3.32656 10.3072 3.51992Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_72",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1311 3.64062C10.1311 3.64062 8.32602 4.17067 8.03269 4.79626C7.73936 5.42185 8.4411 6.09748 9.12704 5.7881C9.81298 5.47872 10.1311 3.64062 10.1311 3.64062Z",
    fill: "white"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M5.57101 14.3332C6.27588 13.8047 7.06168 13.3959 7.89734 13.1229L8.12297 13.0547L8.1681 13.2822C8.18615 13.3686 8.5562 15.4183 7.28134 16.9857C6.00649 18.553 4.66169 18.3915 4.60753 18.3824H4.5263L4.47441 18.3233C4.44056 18.2823 4.40671 18.2391 4.37738 18.1959C3.75011 17.27 4.07277 15.5024 5.57101 14.3332ZM6.95868 16.7081C7.86123 15.6048 7.83641 14.1876 7.78677 13.6166C7.08929 13.8751 6.43205 14.2328 5.835 14.6789C4.55338 15.6731 4.23072 17.1813 4.74292 17.9343C4.74892 17.9413 4.75421 17.9489 4.75871 17.957C5.0385 17.9729 5.99295 17.9047 6.95868 16.7172V16.7081Z",
    fill: "#681D07"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M4.64817 18.1752C4.64817 18.1752 5.90046 18.3618 7.13019 16.8558C8.35992 15.3498 7.96731 13.332 7.96731 13.332C7.15692 13.6013 6.39498 14.0007 5.71093 14.515C4.29843 15.6023 3.93967 17.354 4.64817 18.1752Z",
    fill: "url(#paint19_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_75",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89732 13.5463C7.89732 13.5463 7.99886 15.8211 6.76913 16.8653C5.5394 17.9095 4.57367 16.5559 5.01366 15.6437C5.45366 14.7315 7.76194 13.3734 7.89732 13.5463Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_76",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 13.7031C7.74164 13.7031 6.09223 14.5926 5.92074 15.266C5.74926 15.9393 6.58186 16.4557 7.19334 16.0121C7.80482 15.5685 7.74164 13.7031 7.74164 13.7031Z",
    fill: "white"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M38.9925 11.031C39.956 8.69472 34.1616 8.12145 30.5469 8.11463C29.7053 6.54952 27.2639 2.16813 25.6348 0.957899C23.8297 -0.388822 20.594 4.88204 18.7054 8.12373C15.2261 8.04638 8.43888 8.51728 9.47681 11.031C10.332 13.1102 13.2901 16.2518 15.0772 18.0308C13.9896 21.1564 12.1393 28.5202 14.9598 28.2495C17.5705 27.9992 22.4284 25.3809 24.2335 24.364C26.0387 25.3809 30.8966 28.0038 33.5073 28.2495C36.33 28.5202 34.4865 21.1519 33.3945 18.0308C35.1793 16.2518 38.1329 13.1102 38.9925 11.031Z",
    fill: "#EEC700"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M39.5295 9.53626C38.3472 7.74594 33.7148 7.41154 30.9846 7.37514C29.809 5.23222 27.6565 1.53556 26.0702 0.359452C25.7592 0.124266 25.3804 -0.00195508 24.9917 2.28974e-05C22.9181 2.28974e-05 20.5466 3.53289 18.288 7.37287H17.9879C15.6976 7.37287 10.2304 7.58443 8.93978 9.53399C8.7665 9.7937 8.66259 10.0941 8.63808 10.4061C8.61357 10.7181 8.6693 11.0312 8.79988 11.3152C9.62346 13.333 12.1845 16.1743 14.2287 18.2308C13.5947 20.1735 11.8325 26.1246 13.2968 28.2129C13.4644 28.4606 13.6906 28.6623 13.955 28.7998C14.2194 28.9372 14.5135 29.006 14.8109 29C14.8808 29 14.953 29 15.0365 29C17.5592 28.7566 21.8508 26.5523 24.2403 25.2237C26.6298 26.5523 30.9214 28.7566 33.4441 29C33.5208 29 33.5953 29 33.6697 29C33.9671 29.0062 34.2614 28.9375 34.5257 28.8001C34.7901 28.6626 35.0163 28.4608 35.1837 28.2129C36.6504 26.1269 34.8859 20.1735 34.2519 18.2308C36.2826 16.1834 38.8571 13.333 39.6875 11.3152C39.815 11.03 39.8675 10.7165 39.8399 10.4049C39.8122 10.0932 39.7053 9.79409 39.5295 9.53626ZM15.7676 18.2786L15.9233 17.835L15.5916 17.5028C13.9106 15.8263 10.966 12.7256 10.1537 10.7465C10.1169 10.6888 10.0973 10.6217 10.0973 10.5531C10.0973 10.4846 10.1169 10.4174 10.1537 10.3598C10.6479 9.61361 13.4932 8.85835 17.9788 8.85835C18.218 8.85835 18.4527 8.85835 18.6806 8.85835H19.1115L19.3372 8.483C22.7218 2.68664 24.2764 1.46959 24.9894 1.46959C25.0639 1.46812 25.1366 1.49308 25.1947 1.54011C26.7223 2.67754 29.1795 7.11808 29.8948 8.45115L30.1046 8.84243H30.5424C34.9897 8.84243 37.8124 9.60223 38.3021 10.3438C38.3394 10.4013 38.3593 10.4685 38.3593 10.5372C38.3593 10.6059 38.3394 10.6731 38.3021 10.7306C37.4898 12.7074 34.5452 15.8103 32.8642 17.4869L32.5325 17.8191L32.6882 18.2627C33.9157 21.7705 34.7189 26.2565 33.9563 27.3394C33.9246 27.3928 33.8785 27.4362 33.8234 27.4644C33.7683 27.4925 33.7064 27.5044 33.6449 27.4986H33.5682C31.0455 27.2575 26.0522 24.5413 24.581 23.7041L24.2222 23.5017L23.8635 23.7041C22.3923 24.5322 17.399 27.2575 14.8786 27.4986H14.8019C14.7401 27.5038 14.6781 27.4917 14.6228 27.4636C14.5674 27.4355 14.5209 27.3925 14.4882 27.3394C13.7391 26.2702 14.5424 21.7864 15.7676 18.2786Z",
    fill: "#681D07"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M38.9925 11.031C39.956 8.69472 34.1616 8.12145 30.5469 8.11463C29.7053 6.54952 27.2639 2.16813 25.6348 0.957899C23.8297 -0.388822 20.594 4.88204 18.7054 8.12373C15.2261 8.04638 8.43888 8.51728 9.47681 11.031C10.332 13.1102 13.2901 16.2518 15.0772 18.0308C13.9896 21.1564 12.1393 28.5202 14.9598 28.2495C17.5705 27.9992 22.4284 25.3809 24.2335 24.364C26.0387 25.3809 30.8966 28.0038 33.5073 28.2495C36.33 28.5202 34.4865 21.1519 33.3945 18.0308C35.1793 16.2518 38.1329 13.1102 38.9925 11.031Z",
    fill: "url(#paint20_linear_5253_13096)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M36.6143 11.6028C37.4221 9.64412 32.5528 9.16185 29.5293 9.1573C28.823 7.84242 26.7765 4.16624 25.4069 3.15165C23.8861 2.01421 21.1807 6.44566 19.5967 9.16185C16.6769 9.08677 10.9841 9.4826 11.8528 11.6028C12.5703 13.3476 15.0523 15.9819 16.5506 17.4742C15.6345 20.0926 14.0889 26.2734 16.4535 26.0482C18.6445 25.8366 22.7195 23.6414 24.2336 22.786C25.7498 23.6414 29.8249 25.8366 32.0136 26.0482C34.3805 26.2757 32.8326 20.0926 31.9188 17.4742C33.4148 15.9705 35.8968 13.3362 36.6143 11.6028Z",
    fill: "url(#paint21_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.43
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M33.3945 16.4548C33.5163 16.8029 33.6472 17.2055 33.7803 17.6423C35.5854 15.8224 38.196 12.9674 38.9926 11.0315C39.0858 10.8366 39.1195 10.6182 39.0894 10.4039C39.0592 10.1896 38.9666 9.98923 38.8233 9.82812C37.7967 11.8937 35.0755 14.7873 33.3945 16.4548Z",
    fill: "#DB5800"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M15.0749 16.4555C13.3916 14.788 10.6682 11.8921 9.64377 9.82422C9.50044 9.98627 9.40806 10.1876 9.37833 10.4026C9.3486 10.6177 9.38288 10.8368 9.4768 11.0322C10.271 12.9681 12.8884 15.823 14.6868 17.6429C14.8222 17.2062 14.953 16.8035 15.0749 16.4555Z",
    fill: "#DB5800"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_83",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5072 26.6706C30.8966 26.4204 26.0409 23.8043 24.2335 22.7852C22.4284 23.8043 17.5704 26.4249 14.9598 26.6706C14.0414 26.7593 13.6195 26.0359 13.5022 24.9167C13.351 26.8731 13.6579 28.3745 14.9598 28.2494C17.5704 27.9991 22.4284 25.3808 24.2335 24.3639C26.0386 25.3808 30.8966 28.0037 33.5072 28.2494C34.8092 28.3745 35.116 26.8731 34.9649 24.9167C34.8475 26.0359 34.4256 26.7593 33.5072 26.6706Z",
    fill: "#DB5800"
  })))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M18.1774 25.111C18.3263 25.0496 22.2389 23.3753 23.3039 22.6609C24.3689 21.9466 24.4005 22.0809 27.4489 23.8871C30.4972 25.6933 32.0609 25.9572 32.6115 25.4795C33.162 25.0018 32.7942 26.2393 31.3411 25.9095C29.888 25.5796 25.0097 23.3844 24.6216 23.0727C24.2335 22.761 19.3755 25.8298 17.0424 25.9322C14.7093 26.0346 16.431 25.823 18.1774 25.111Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_85",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5293 9.14558C28.823 7.8307 26.7765 4.15452 25.4069 3.13993C23.8861 2.0025 21.1807 6.43394 19.5967 9.15013C16.6769 9.08643 10.9841 9.48226 11.8528 11.6024C12.5703 13.3473 15.0523 15.9816 16.5506 17.4739C16.3249 18.1336 16.0497 19.0185 15.8105 19.9762C18.6016 20.3811 22.442 19.3233 25.2399 18.2814C29.9648 16.523 31.542 16.1476 36.4789 11.9118C36.5286 11.8117 36.576 11.7116 36.6143 11.6138C37.4221 9.6324 32.5619 9.15013 29.5293 9.14558Z",
    fill: "white"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    opacity: 0.49,
    d: "M29.5293 9.14558C28.823 7.8307 26.7765 4.15452 25.4069 3.13993C23.8861 2.0025 21.1807 6.43394 19.5967 9.15013C16.6769 9.08643 10.9841 9.48226 11.8528 11.6024C11.8528 11.6161 11.8663 11.632 11.8708 11.6457C12.62 10.2625 17.1124 9.985 19.5967 10.0396C21.1762 7.32113 23.8838 2.90107 25.4069 4.0294C26.7765 5.04399 28.823 8.72018 29.5293 10.0328C32.0745 10.0328 35.9081 10.3786 36.5963 11.6457C36.6032 11.6317 36.6093 11.6172 36.6143 11.6024C37.4221 9.6324 32.5619 9.15013 29.5293 9.14558Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M24.8698 2.95718C24.1433 2.93898 22.3382 4.64513 21.0521 6.76075C19.7659 8.87638 23.7597 4.50863 24.8698 4.59053C25.98 4.67243 26.262 2.99812 24.8698 2.95718Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M25.7905 1.21618C25.7905 1.21618 25.6415 3.08384 25.2489 2.87456C25.1097 2.80199 24.9527 2.77134 24.7967 2.78626C24.6406 2.80118 24.4922 2.86105 24.3689 2.95873L23.9944 1.2139C23.9944 1.2139 24.9985 0.265285 25.7905 1.21618Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M10.0522 9.61719C10.5555 9.72696 11.0379 9.91825 11.4805 10.1836L12.013 10.5544C11.827 10.7338 11.7156 10.9778 11.7016 11.2369C11.7016 11.6236 11.7625 11.6623 11.7625 11.6623C11.7625 11.6623 9.58059 11.4689 9.39331 10.7523C9.20603 10.0358 9.80849 9.69908 10.0522 9.61719Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_90",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.43
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2727 9.47388C37.9173 9.61872 37.5765 9.79775 37.2551 10.0085C37.0296 10.1417 36.8404 10.3293 36.7045 10.5544C36.7498 10.703 36.7823 10.8552 36.8016 11.0094V11.3734C36.8016 11.3734 38.2095 11.2164 38.6405 10.9935C39.0715 10.7706 39.0489 10.129 38.9361 9.97207C38.8233 9.81511 38.4036 9.41928 38.2727 9.47388Z",
    fill: "#DB5800"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_91",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.43
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8939 26.0034C15.8939 26.0034 15.2915 27.9939 15.1177 28.1236C14.944 28.2533 14.2152 28.3511 13.9444 27.8643C13.6737 27.3775 13.536 27.043 13.6692 26.7587C13.8023 26.4743 15.3908 25.5234 15.3908 25.5234C15.3908 25.5234 15.6074 26.0034 15.8939 26.0034Z",
    fill: "#DB5800"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_92",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.43
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4581 26.0034C32.4581 26.0034 33.0583 27.9939 33.2343 28.1236C33.4103 28.2533 34.1368 28.3511 34.4053 27.8643C34.6738 27.3775 34.816 27.043 34.6829 26.7587C34.5497 26.4743 32.9612 25.5234 32.9612 25.5234C32.9612 25.5234 32.7446 26.0034 32.4581 26.0034Z",
    fill: "#DB5800"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_93",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.43
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3824 23.0859V24.3644C24.3824 24.3644 17.1169 28.0474 16.194 28.2317L15.2734 28.4114L16.194 26.4368C16.194 26.4368 23.5679 23.7843 24.3824 23.0859Z",
    fill: "#DB5800"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_94",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5967 9.14836L18.7054 8.1224C18.7054 8.1224 21.0024 3.77513 22.6992 2.23732C24.396 0.699508 25.2715 0.351454 25.2715 1.61173C25.2715 2.87201 24.8698 2.95618 24.8698 2.95618C24.8698 2.95618 22.9767 3.11997 19.5967 9.14836Z",
    fill: "white"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M28.7598 14.4651C29.4013 13.7536 29.7484 12.8217 29.7301 11.8604C29.7301 9.88353 28.1506 7.76562 24.6938 7.76562C23.1279 7.76562 21.4672 8.18648 20.4586 8.83709L19.7343 9.30571L20.9347 13.5961L21.5056 13.2549V16.8355H23.7778C24.0305 16.8355 24.9691 16.922 24.9691 17.3474C24.9691 17.7318 24.1568 17.7523 23.9944 17.7523C23.2344 17.716 22.4914 17.5134 21.817 17.1585L20.5331 16.4852L19.3823 20.7847L20.1066 21.2397C21.0881 21.863 22.6541 22.252 24.1907 22.252C25.8784 22.252 27.3338 21.8152 28.3966 20.9894C28.9365 20.5816 29.3742 20.0518 29.6743 19.4426C29.9745 18.8334 30.1288 18.1618 30.125 17.4816C30.1285 16.909 30.0082 16.3425 29.7724 15.8215C29.5367 15.3006 29.1911 14.8377 28.7598 14.4651ZM28.0107 20.489C27.0585 21.2306 25.7385 21.6264 24.1907 21.6264C22.7669 21.6264 21.3318 21.2738 20.4451 20.7164L20.1156 20.5072L20.946 17.4293L21.5259 17.7318C22.2909 18.132 23.1334 18.3587 23.9944 18.3961C25.0007 18.3961 25.6009 18.0071 25.6009 17.3542C25.6009 16.5057 24.6194 16.2031 23.7778 16.2031H22.1374V13.1548H23.7168C24.2945 13.1548 25.2715 12.9546 25.2715 12.3313C25.2715 11.8922 24.8202 11.6329 24.0756 11.6329C23.3127 11.6663 22.5686 11.8823 21.905 12.263L21.3138 12.6156L20.4722 9.58097L20.8016 9.36713C21.7041 8.77794 23.2407 8.39576 24.6938 8.39576C27.7197 8.39576 29.0983 10.1906 29.0983 11.8604C29.111 12.311 29.0257 12.759 28.8484 13.1728C28.671 13.5867 28.4059 13.9563 28.0716 14.2558L27.7761 14.522L28.0987 14.7495C28.5325 15.0572 28.8858 15.4663 29.1287 15.9416C29.3715 16.417 29.4966 16.9446 29.4932 17.4793C29.4977 18.0631 29.3658 18.6397 29.1083 19.1625C28.8507 19.6854 28.4748 20.1398 28.0107 20.489ZM22.8775 12.5133C23.2624 12.3628 23.6697 12.2789 24.0824 12.2653C24.2494 12.2622 24.416 12.2844 24.5765 12.3313C24.3049 12.4516 24.0113 12.5136 23.7146 12.5133H22.8775Z",
    fill: "#681D07"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M26.341 15.1487L25.9078 15.0691V14.2115L26.2598 14.0864C27.4421 13.6701 28.0423 12.9194 28.0423 11.857C28.0423 10.3988 26.7269 9.45703 24.6939 9.45703C23.7636 9.45924 22.8412 9.62952 21.9704 9.95978L21.7042 10.0667L21.9749 11.0312L22.2953 10.9175C22.8672 10.7003 23.4715 10.5826 24.0824 10.5694C25.7453 10.5694 26.3388 11.5181 26.3388 12.3325C26.3396 12.5895 26.2794 12.8429 26.1632 13.0717C26.047 13.3004 25.8782 13.4978 25.6709 13.6473L25.5603 13.7315L25.4317 13.8066C24.9103 14.0867 24.3279 14.2313 23.7372 14.2274H23.1934V15.1374H23.7778C24.3533 15.1202 24.9253 15.2329 25.452 15.4672L25.6258 15.5537L25.7769 15.6606C26.0521 15.8413 26.2772 16.0895 26.4311 16.382C26.5851 16.6745 26.6627 17.0016 26.6569 17.3326C26.6569 18.304 25.9597 19.4391 23.9944 19.4391C23.296 19.4269 22.6048 19.2954 21.9501 19.0501L21.6274 18.9341L21.3431 19.9897L21.6071 20.0943C22.4334 20.4044 23.3091 20.5586 24.1907 20.5493C26.7697 20.5493 28.4372 19.3436 28.4372 17.4805C28.4304 16.0405 27.3022 15.3239 26.341 15.1487ZM25.3956 10.144C26.6389 10.3147 27.4083 10.9493 27.4083 11.8593C27.4176 12.0922 27.3712 12.3239 27.273 12.5349C27.1748 12.746 27.0278 12.9301 26.8442 13.0718C26.9266 12.8334 26.9686 12.5827 26.9683 12.3302C26.9698 11.8445 26.8183 11.3709 26.5357 10.9776C26.253 10.5843 25.8538 10.2916 25.3956 10.1418V10.144ZM25.2715 14.7142C25.2016 14.6892 25.1316 14.6688 25.0594 14.6483C25.1316 14.6255 25.2016 14.6028 25.2715 14.5755V14.7142ZM25.7792 19.719C26.2343 19.5136 26.6206 19.1795 26.8909 18.7571C27.1613 18.3347 27.3042 17.8422 27.3022 17.3394C27.3053 16.8888 27.1942 16.4449 26.9796 16.0496C27.2358 16.1891 27.4492 16.3966 27.5967 16.6496C27.7443 16.9026 27.8204 17.1915 27.8167 17.485C27.8054 18.5633 27.045 19.3641 25.7814 19.7167L25.7792 19.719Z",
    fill: "#681D07"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M24.1275 21.9389C22.6473 21.9389 21.1468 21.5681 20.2127 20.9743L19.6847 20.6377L20.6798 16.9501L21.6094 17.4369C22.329 17.8135 23.1213 18.0278 23.9312 18.0648C24.3193 18.0648 25.2219 17.9943 25.2219 17.3414C25.2219 16.5202 23.7778 16.5088 23.7146 16.5088H21.7583V12.8349H23.6537C24.2539 12.8212 24.8992 12.6256 24.8992 12.3299C24.8992 11.9681 24.1681 11.9499 24.0215 11.9499C23.3149 11.9835 22.6261 12.1846 22.011 12.5369L21.0656 13.101L20.0412 9.43622L20.5669 9.09954C21.5282 8.4785 23.1234 8.07812 24.6284 8.07812C27.8731 8.07812 29.3488 10.0391 29.3488 11.8612C29.361 12.3565 29.2664 12.8485 29.0716 13.3033C28.8768 13.7581 28.5865 14.1649 28.2206 14.4955C28.6976 14.8316 29.086 15.2799 29.3522 15.8016C29.6184 16.3233 29.7543 16.9026 29.7482 17.4892C29.7518 18.1205 29.6085 18.7439 29.3299 19.3092C29.0513 19.8746 28.6451 20.3662 28.1439 20.7446C27.133 21.5249 25.7453 21.9389 24.1275 21.9389ZM21.6613 19.8051C22.4497 20.1027 23.2856 20.2523 24.1275 20.2464C26.5148 20.2464 28.0581 19.1658 28.0581 17.4961C28.0581 16.2494 27.0698 15.6261 26.2237 15.4737L25.8943 15.4146C26.2118 15.6248 26.4716 15.9125 26.6495 16.2509C26.8274 16.5893 26.9176 16.9675 26.9119 17.3505C26.9119 18.5584 25.989 19.7755 23.9312 19.7755C23.1969 19.7614 22.4702 19.6237 21.7809 19.3683L21.6613 19.8051ZM23.4461 14.8004H23.7146C24.3372 14.7887 24.9543 14.9193 25.5197 15.1825V14.0678C24.9514 14.3735 24.3158 14.53 23.6717 14.5228H23.4461V14.8004ZM24.0215 10.237C25.795 10.237 26.587 11.2834 26.587 12.3208C26.5881 12.625 26.5175 12.9251 26.3809 13.1965C26.2444 13.4678 26.0459 13.7025 25.8017 13.8813L26.0928 13.7789C27.1488 13.4059 27.6723 12.7735 27.6723 11.8499C27.6723 10.585 26.4832 9.76835 24.6397 9.76835C23.7495 9.77001 22.8668 9.93258 22.0336 10.2483L22.1329 10.6055C22.737 10.3752 23.3757 10.2506 24.0215 10.237Z",
    fill: "url(#paint22_linear_5253_13096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_98",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0756 18.9124C25.5513 18.8055 25.9213 17.9615 25.9913 17.7864C26.0328 17.6854 26.0543 17.5772 26.0544 17.4679L25.1519 17.6089C24.9398 18.0139 24.2493 18.0639 23.9244 18.0639C23.1144 18.0272 22.3221 17.8129 21.6026 17.436L20.673 16.9492L21.21 18.1845C21.21 18.1845 22.5977 19.0171 24.0756 18.9124Z",
    fill: "white"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    opacity: 0.46,
    d: "M20.1856 21.0239C21.1197 21.6199 22.6202 21.9885 24.1004 21.9885C25.7182 21.9885 27.1059 21.5744 28.1145 20.7919C28.3741 20.592 28.6103 20.3631 28.8185 20.1094L28.0107 19.75L26.341 19.8865C25.6287 20.1722 24.8668 20.3106 24.1004 20.2937C23.6518 20.2943 23.204 20.2547 22.7624 20.1754L20.7023 20.3415L19.7343 20.7441L20.1856 21.0239Z",
    fill: "#681D07"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    opacity: 0.46,
    d: "M28.2183 14.4929L26.3726 14.6272C26.3726 14.6272 28.137 14.0493 28.4033 12.6685C28.5462 11.8098 28.3754 10.9281 27.9227 10.1866L28.7102 9.84766C28.7102 9.84766 29.6421 11.1011 29.2991 12.5593C28.9561 14.0175 28.3446 14.4838 28.2183 14.4929Z",
    fill: "#681D07"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_101",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6307 8.07422C23.2272 8.07422 21.747 8.42227 20.7745 8.97052L20.048 9.45734L21.0227 9.80312C21.9489 9.29567 22.9774 9.00708 24.0305 8.95914C25.7205 8.90682 27.916 10.1853 27.916 10.1853L28.7035 9.84634C27.9792 8.83402 26.6501 8.07422 24.6307 8.07422Z",
    fill: "white"
  }))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M21.2213 18.1994C22.0602 18.638 22.9846 18.885 23.9289 18.9228C25.3459 18.9228 26.0635 18.2404 26.0635 17.3486C26.0635 16.1907 24.915 15.6652 23.7123 15.6652H22.5999V13.6861H23.6604C24.563 13.6679 25.7408 13.3244 25.7408 12.3212C25.7408 11.6137 25.1677 11.0905 24.0192 11.0905C23.1609 11.1239 22.3234 11.3659 21.5778 11.7957L21.0204 9.80517C21.7199 9.35019 23.1211 8.91797 24.6307 8.91797C27.1262 8.91797 28.5071 10.2397 28.5071 11.8503C28.5071 13.0992 27.8076 14.0751 26.3726 14.5801V14.6165C27.7715 14.869 28.902 15.9382 28.902 17.476C28.902 19.5552 27.0969 21.0771 24.1275 21.0771C22.6202 21.0885 21.3454 20.7018 20.6639 20.2468L21.2213 18.1994Z",
    fill: "url(#paint23_linear_5253_13096)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M28.5026 11.9708C28.5026 11.9299 28.5026 11.8889 28.5026 11.848C28.5026 10.2374 27.1217 8.91797 24.6261 8.91797C23.1189 8.91797 21.7177 9.35019 21.0159 9.80289L21.0836 10.0304C21.8012 9.5936 23.1617 9.18413 24.6239 9.18413C27.045 9.19323 28.4169 10.4308 28.5026 11.9708Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M26.3726 14.8958C27.7264 15.1393 28.8298 16.1493 28.8998 17.6075C28.8998 17.5643 28.8998 17.521 28.8998 17.4778C28.8998 16.0788 27.9656 15.0687 26.7427 14.707C26.6231 14.7616 26.5012 14.8139 26.3704 14.8594L26.3726 14.8958Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M23.9312 19.1824C25.3482 19.1824 26.0657 18.4999 26.0657 17.6082C26.0657 17.5581 26.0657 17.5103 26.0657 17.4648C25.998 18.2861 25.2828 18.9048 23.9379 18.9048C22.9935 18.8681 22.0688 18.6211 21.2303 18.1814L20.6639 20.2447L20.7294 20.2834L21.2213 18.4635C22.0613 18.9008 22.9865 19.1463 23.9312 19.1824Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M25.7431 12.5981C25.7431 12.5503 25.7431 12.5025 25.7431 12.457C25.6393 13.3465 24.5404 13.6604 23.6694 13.6786H22.6089V13.9539H23.6694C24.5765 13.9357 25.7431 13.5922 25.7431 12.5981Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    opacity: 0.46,
    d: "M21.58 11.8049L21.0656 13.1016C21.0656 13.1016 22.8391 11.8868 23.9605 11.9642C25.0819 12.0415 24.8991 12.3213 24.8991 12.3213L25.5761 11.7231C25.5761 11.7231 25.2128 10.9974 23.771 11.0997C22.3291 11.2021 21.58 11.8049 21.58 11.8049Z",
    fill: "#681D07"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    opacity: 0.46,
    d: "M22.6022 15.6581L21.7583 16.5089C21.7583 16.5089 24.1884 16.4793 24.5337 16.6295C24.6899 16.6929 24.8408 16.7689 24.9849 16.8569L25.5964 16.2586C25.5964 16.2586 24.8067 15.4693 22.6022 15.6581Z",
    fill: "#681D07"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_109",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7583 12.8347L22.6022 13.6786C22.6022 13.6786 23.956 13.7674 24.7548 13.4989C24.9879 13.415 25.1982 13.2769 25.3687 13.0959C25.5392 12.915 25.6651 12.6961 25.7363 12.457L24.7841 12.5367C24.7841 12.5367 24.7164 12.9666 21.7583 12.8347Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_110",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3997 14.6282V14.5918C27.8347 14.0845 28.5342 13.1086 28.5342 11.862C28.5342 10.2514 27.1533 8.92969 24.6578 8.92969C23.1505 8.92969 21.7493 9.36419 21.0475 9.81689L21.6049 11.8074C22.3505 11.3776 23.188 11.1357 24.0463 11.1022C25.1948 11.1022 25.7679 11.6254 25.7679 12.3329C25.7679 13.327 24.6013 13.6705 23.6875 13.6978H22.627V15.6701H23.7394C24.2633 15.6588 24.7821 15.7759 25.2512 16.0113C26.011 15.8387 26.7118 15.4658 27.2819 14.9308C27.0029 14.7899 26.7061 14.6881 26.3997 14.6282Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    style: {
      mixBlendMode: "overlay"
    },
    d: "M23.6762 1.41406C22.205 1.41406 21.0137 2.5333 21.0137 3.91642C21.0137 5.29953 22.205 6.41877 23.6762 6.41877C25.1474 6.41877 26.341 5.29953 26.341 3.91642C26.341 2.5333 25.1474 1.41406 23.6762 1.41406Z",
    fill: "url(#paint24_radial_5253_13096)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    opacity: 0.7,
    d: "M21.2438 7.20811C21.9591 6.40054 24.0598 3.91638 24.0598 3.91638C24.0598 3.91638 25.8175 0.595077 25.8649 0.504083C25.8649 0.476784 23.6085 3.62747 23.6085 3.62747L21.2438 7.20811Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M24.2561 3.32096C23.6085 2.80912 23.7259 1.37368 23.7191 0.96875V1.36458C23.7191 1.30316 23.7191 1.23718 23.7191 1.22126V0.96875C23.7191 1.08477 23.7191 1.26903 23.683 1.48287C23.683 1.48287 23.4935 2.92286 23.1505 3.22087C22.3788 3.90333 20.4428 3.77139 21.1807 3.78958C23.692 3.84418 23.692 6.31696 23.7168 7.12909V6.72189C23.7168 6.75146 23.7168 6.77648 23.7168 6.79013V7.12909C23.771 5.20683 23.7642 3.99205 25.9597 3.83053C26.6885 3.77366 25.0143 3.9147 24.2561 3.32096Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5253_13096",
    x1: 37.8814,
    y1: 23.1484,
    x2: 37.8827,
    y2: 8.0643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5253_13096",
    x1: 39.3603,
    y1: 28.1359,
    x2: 39.3599,
    y2: 25.5478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5253_13096",
    x1: 45.0974,
    y1: 22.2641,
    x2: 45.0991,
    y2: 19.3323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5253_13096",
    x1: 45.9597,
    y1: 17.3856,
    x2: 45.9596,
    y2: 13.6149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5253_13096",
    x1: 44.6686,
    y1: 11.9341,
    x2: 44.6689,
    y2: 7.40337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5253_13096",
    x1: 36.0952,
    y1: 26.0797,
    x2: 36.0954,
    y2: 21.0942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5253_13096",
    x1: 38.4,
    y1: 21.1268,
    x2: 38.3794,
    y2: 15.9862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5253_13096",
    x1: 38.9512,
    y1: 13.378,
    x2: 38.9438,
    y2: 10.1455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5253_13096",
    x1: 37.4122,
    y1: 8.04905,
    x2: 37.4026,
    y2: 4.81563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5253_13096",
    x1: 41.8793,
    y1: 17.6766,
    x2: 41.8793,
    y2: 13.8813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5253_13096",
    x1: 8.44856,
    y1: 21.0757,
    x2: 8.47184,
    y2: 5.97276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5253_13096",
    x1: 6.0141,
    y1: 29.9511,
    x2: 6.01474,
    y2: 27.3525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5253_13096",
    x1: 6.67718,
    y1: 22.8836,
    x2: 6.6755,
    y2: 19.9517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5253_13096",
    x1: 1.98307,
    y1: 16.7901,
    x2: 1.98518,
    y2: 13.0194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5253_13096",
    x1: 10.0849,
    y1: 17.6057,
    x2: 10.0692,
    y2: 13.1019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5253_13096",
    x1: 10.2322,
    y1: 24.0136,
    x2: 10.2403,
    y2: 19.0196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5253_13096",
    x1: 7.43511,
    y1: 15.8501,
    x2: 7.45568,
    y2: 10.7095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5253_13096",
    x1: 10.0522,
    y1: 9.67597,
    x2: 10.0617,
    y2: 6.44254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5253_13096",
    x1: 11.5912,
    y1: 4.34703,
    x2: 11.6007,
    y2: 1.1136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5253_13096",
    x1: 9.37577,
    y1: 16.1139,
    x2: 9.38343,
    y2: 12.3237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_5253_13096",
    x1: 24.2335,
    y1: 28.2563,
    x2: 24.2335,
    y2: 0.741786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5253_13096",
    x1: 24.2336,
    y1: 26.0414,
    x2: 24.2336,
    y2: 2.96056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5253_13096",
    x1: 24.7164,
    y1: 22.403,
    x2: 24.7164,
    y2: 4.52251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_5253_13096",
    x1: 24.7841,
    y1: 20.5221,
    x2: 24.7841,
    y2: 7.37106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C320F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB77B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_5253_13096",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.6762 3.91414) scale(2.57453 2.59562)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5253_13096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyAsset51);
export default __webpack_public_path__ + "static/media/happyAsset 5 1.259dcedb8445b395236332937aac7f4d.svg";
export { ForwardRef as ReactComponent };